import { Link } from 'react-router-dom'
import { Linkedin, Twitter } from 'lucide-react'
import { Logo } from '@/components/brand'

const footerNavigation = {
  services: [
    { name: 'Strategic Consulting', href: '/services/consulting' },
    { name: 'Custom Development', href: '/services/development' },
    { name: 'Generative AI', href: '/services/platform' },
    { name: 'Managed Services', href: '/services/managed-services' },
  ],
  company: [
    { name: 'About Us', href: '/about' },
    { name: 'Case Studies', href: '/case-studies' },
    { name: 'Insights', href: '/insights' },
    { name: 'Careers', href: '/careers' },
  ],
  tools: [
    { name: 'ROI Calculator', href: '/tools/roi-calculator' },
    { name: 'Contact Center Assessment', href: '/tools/assessment' },
  ],
  legal: [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' },
  ],
}

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t border-neutral-800 bg-neutral-900/95 backdrop-blur-sm">
      <div className="container-lg py-12 lg:py-16">
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:grid-cols-6 lg:gap-12">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-3 lg:col-span-2">
            <Link to="/" className="flex items-center">
              <Logo variant="full" theme="dark" size="md" />
            </Link>
            <p className="mt-4 text-body-sm text-neutral-400">
              Intelligent customer interaction systems that transform how organizations connect with their customers.
            </p>
            <div className="mt-6 flex gap-4">
              <a
                href="https://linkedin.com/company/truvinetech"
                target="_blank"
                rel="noopener noreferrer"
                className="text-neutral-500 transition-colors hover:text-accent-400"
              >
                <span className="sr-only">LinkedIn</span>
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href="https://twitter.com/truvinetech"
                target="_blank"
                rel="noopener noreferrer"
                className="text-neutral-500 transition-colors hover:text-accent-400"
              >
                <span className="sr-only">Twitter</span>
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-body-sm font-semibold text-white">Services</h3>
            <ul className="mt-4 space-y-3">
              {footerNavigation.services.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-body-sm text-neutral-400 transition-colors hover:text-accent-400"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-body-sm font-semibold text-white">Company</h3>
            <ul className="mt-4 space-y-3">
              {footerNavigation.company.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-body-sm text-neutral-400 transition-colors hover:text-accent-400"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Tools */}
          <div>
            <h3 className="text-body-sm font-semibold text-white">Tools</h3>
            <ul className="mt-4 space-y-3">
              {footerNavigation.tools.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-body-sm text-neutral-400 transition-colors hover:text-accent-400"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-body-sm font-semibold text-white">Contact</h3>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href="tel:+18007272591"
                  className="text-body-sm text-neutral-400 transition-colors hover:text-accent-400"
                >
                  +1 (800) 727-2591
                </a>
              </li>
              <li>
                <a
                  href="mailto:contact@truvinetech.com"
                  className="text-body-sm text-neutral-400 transition-colors hover:text-accent-400"
                >
                  contact@truvinetech.com
                </a>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="inline-flex rounded-xl gradient-primary px-4 py-2 text-body-sm font-medium text-white transition-all hover:scale-105 hover:shadow-lg hover:shadow-accent-400/20"
                >
                  Get in Touch
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-neutral-800 pt-8 md:flex-row">
          <p className="text-body-xs text-neutral-500">
            &copy; {currentYear} Truvine Technologies, LLC. All rights reserved.
          </p>
          <div className="flex gap-6">
            {footerNavigation.legal.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="text-body-xs text-neutral-500 transition-colors hover:text-neutral-300"
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
